import { render, staticRenderFns } from "./videoAnalyze.vue?vue&type=template&id=3b91e750&scoped=true"
import script from "./videoAnalyze.vue?vue&type=script&lang=js"
export * from "./videoAnalyze.vue?vue&type=script&lang=js"
import style0 from "./videoAnalyze.vue?vue&type=style&index=0&id=3b91e750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b91e750",
  null
  
)

export default component.exports